import { render, staticRenderFns } from "./EditPreference.vue?vue&type=template&id=3d27668a&"
import script from "./EditPreference.vue?vue&type=script&lang=js&"
export * from "./EditPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports